var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 800,
    viewBox: "0 0 800 800",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M635.938 200H289.062C239.875 200 200 239.875 200 289.062V635.938C200 685.125 239.875 725 289.062 725H635.938C685.125 725 725 685.125 725 635.938V289.062C725 239.875 685.125 200 635.938 200Z",
    stroke: "white",
    strokeWidth: 50,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M599.219 200L600 162.5C599.934 139.314 590.694 117.096 574.299 100.701C557.904 84.3059 535.686 75.066 512.5 75H175C148.502 75.0783 123.113 85.6392 104.376 104.376C85.6392 123.113 75.0783 148.502 75 175V512.5C75.066 535.686 84.3059 557.904 100.701 574.299C117.096 590.694 139.314 599.934 162.5 600H200",
    stroke: "white",
    strokeWidth: 50,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M462.5 337.5V587.5",
    stroke: "white",
    strokeWidth: 50,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M587.5 462.5H337.5",
    stroke: "white",
    strokeWidth: 50,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoCopy);
export default __webpack_public_path__ + "static/media/ico_copy.da9403d8810eac10f2895a70a1333ff0.svg";
export { ForwardRef as ReactComponent };